import type { LinearBuild } from './shape';

export const LINEAR_BUILDS: LinearBuild[] = [
  {
    id: 'linear-01',
  },
];
